"use client";

import { Input } from "@headlessui/react";
import { debounce } from "lodash";
import { useEffect, useRef, useState } from "react";
import Pagination from "./Pagination";
import { fetchAllPatientenDetails } from "../apiCalls/usersApi";

const SelectPatientPagination = ({ setData, setLoading, setError, placeholder = "Zoeken patient op" }) => {
  const [search, setSearch] = useState(() => localStorage.getItem("QUERY") || ""); // ✅ initialize from storage
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(4);
  const debouncedFetchRef = useRef();

  // Debounced fetch when page/pageSize change
  useEffect(() => {
    debouncedFetchRef.current = debounce((query) => {
      fetchAllPatientenDetails(
        pageSize,
        page,
        query,
        setLoading,
        setError,
        setData
      );
    }, 300);

    return () => {
      debouncedFetchRef.current?.cancel();
    };
  }, [pageSize, page, setLoading, setError, setData]);

  // Debounced search
  useEffect(() => {
    localStorage.setItem("QUERY", search); // ✅ store the query
    if (debouncedFetchRef.current) {
      debouncedFetchRef.current(search);
    }
  }, [search]);

  // Immediate fetch on page/pageSize change
  useEffect(() => {
    fetchAllPatientenDetails(pageSize, page, search, setLoading, setError, setData);
  }, [page, pageSize]);

  return (
    <div className="flex w-full dark:bg-gray-800 items-center px-5 rounded-md">
      <Input
        placeholder={placeholder}
        className="block w-full rounded-md bg-white py-1.5 pl-3 pr-12 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
      />

      <Pagination
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        pageRanges={[4, 8, 16, 32, 64, 128]}
      />
    </div>
  );
};

export default SelectPatientPagination;
